<template>
    <span>
        <ul v-if="data && data.length" :class="[prefixCls + '-menu']">
            <Casitem
                v-for="item in data"
                :key="getKey()"
                :prefix-cls="prefixCls"
                :data="item"
                :tmp-item="tmpItem"
                @click.native.stop="handleClickItem(item, $event)"
                @mouseenter.native.stop="handleHoverItem(item)"
                ></Casitem>
        </ul>
        <CaseInsensitiveCaspanel
            v-if="sublist && sublist.length"
            :prefix-cls="prefixCls"
            :data="sublist"
            :disabled="disabled"
            :trigger="trigger"
            :change-on-select="changeOnSelect">
        </CaseInsensitiveCaspanel>
    </span>
</template>
<script>
    import Emitter from 'iview/src/mixins/emitter';
import { findComponentDownward, findComponentUpward } from 'iview/src/utils/assist';
import Casitem from './casitem.vue';

    let key = 1;

    export default {
        name: 'CaseInsensitiveCaspanel',
        mixins: [ Emitter ],
        components: { Casitem },
        props: {
            data: {
                type: Array,
                default () {
                    return [];
                }
            },
            disabled: Boolean,
            changeOnSelect: Boolean,
            trigger: String,
            prefixCls: String
        },
        data () {
            return {
                tmpItem: {},
                result: [],
                sublist: []
            };
        },
        watch: {
            data () {
                this.sublist = [];
            }
        },
        methods: {
            isIcon(node){
                let nodeName = (node.nodeName || "").toLocaleUpperCase();
                let isIvu = node.classList.contains("ivu-icon");
                if(nodeName == "I" && isIvu){
                    return true;
                }
                return false;
            },
            handleClickItem (item, ev) {
                let isIcon = this.isIcon(ev.target);
                if (this.trigger !== 'click' && item.children && item.children.length) return;
                this.handleTriggerItem(item, false, true, isIcon);
            },
            handleHoverItem (item) {
                if (this.trigger !== 'hover' || !item.children || !item.children.length) return;
                this.handleTriggerItem(item, false, true, false);
            },
            handleTriggerItem (item, fromInit = true, fromUser = false, isIcon = false) {
                if (item.disabled) return;

                const cascader = findComponentUpward(this, 'CaseInsensitiveCascader');
                if (item.loading !== undefined && !item.children.length) {
                    if (cascader && cascader.loadData) {
                        cascader.loadData(item, () => {
                            if (fromUser) {
                                cascader.isLoadedChildren = true;
                            }
                            if (item.children.length) {
                                this.handleTriggerItem(item);
                            }
                        });
                        return;
                    }
                }

                const backItem = this.getBaseItem(item);
                if (
                    this.changeOnSelect ||
                    (backItem.label !== this.tmpItem.label || backItem.value !== this.tmpItem.value) ||
                    (backItem.label === this.tmpItem.label && backItem.value === this.tmpItem.value)
                ) {
                    this.tmpItem = backItem;
                    this.emitUpdate([backItem]);
                }

                if (item.children && item.children.length){
                    this.sublist = item.children;
                    !isIcon && this.dispatch('CaseInsensitiveCascader', 'on-result-change', {
                        lastValue: false,
                        changeOnSelect: this.changeOnSelect,
                        fromInit: fromInit
                    });

                    if (this.changeOnSelect) {
                        const Caspanel = findComponentDownward(this, 'CaseInsensitiveCaspanel');
                        if (Caspanel) {
                            Caspanel.$emit('on-clear', true);
                        }
                    }
                } else {
                    this.sublist = [];
                    !isIcon && this.dispatch('CaseInsensitiveCascader', 'on-result-change', {
                        lastValue: true,
                        changeOnSelect: this.changeOnSelect,
                        fromInit: fromInit
                    });
                }

                if (cascader) {
                    cascader.$refs.drop.update();
                }
            },
            updateResult (item) {
                this.result = [this.tmpItem].concat(item);
                this.emitUpdate(this.result);
            },
            getBaseItem (item) {
                let backItem = Object.assign({}, item);
                if (backItem.children) {
                    delete backItem.children;
                }
                return backItem;
            },
            emitUpdate (result) {
                if (this.$parent.$options.name === 'CaseInsensitiveCaspanel') {
                    this.$parent.updateResult(result);
                } else {
                    this.$parent.$parent.updateResult(result);
                }
            },
            getKey () {
                return key++;
            }
        },
        mounted () {
            this.$on('on-find-selected', (params) => {
                const val = params.value;
                let value = [...val];
                for (let i = 0; i < value.length; i++) {
                    for (let j = 0; j < this.data.length; j++) {
                        if (value[i] === this.data[j].value) {
                            this.handleTriggerItem(this.data[j], true);
                            value.splice(0, 1);
                            this.$nextTick(() => {
                                this.broadcast('CaseInsensitiveCaspanel', 'on-find-selected', {
                                    value: value
                                });
                            });
                            return false;
                        }
                    }
                }
            });
            this.$on('on-clear', (deep = false) => {
                this.sublist = [];
                this.tmpItem = {};
                if (deep) {
                    const Caspanel = findComponentDownward(this, 'CaseInsensitiveCaspanel');
                    if (Caspanel) {
                        Caspanel.$emit('on-clear', true);
                    }
                }
            });
        }
    };
</script>